export default {
  api: {
    baseURL: 'https://frontlines.parkings.mc/'
  },
  googleMaps: {
    apiKey: 'AIzaSyAWEI45FhMtiSi5-XQI1oO4MJUHf5dWITw'
  },
  reCaptcha: {
    sitekey: '6Lczn1AUAAAAAI20OeXfnvSh1aGnvbCljTDOveSw'
  },
  timestamp: {
    refreshFrequency: 1 * 1000,
    timeToBan: 15 * 60 * 1000
  },
  toolymctoolface: {
    ignoreCache: true
  }
};



// WEBPACK FOOTER //
// ./src/config/index.js